<template>
  <el-dialog :title="type === 'IMPORT' ? '导入记录' : '导出记录'" :visible="visible" width="1050px" append-to-body @update:visible="$emit('update:visible', $event)" @open="open">
    <div class="records-toolbar"><span>文件与处理结果按当前账号保存</span><el-button size="small" icon="el-icon-refresh" :loading="loading" @click="fetchRecords">刷新</el-button></div>
    <el-table v-loading="loading" :data="items" border size="small" empty-text="暂无记录">
      <el-table-column prop="fileName" label="文件名" min-width="220" show-overflow-tooltip>
        <template slot-scope="{ row }"><el-button v-if="row.downloadable" type="text" :loading="downloading === row.id" v-permission="type === 'IMPORT' ? 'waybill:import' : 'waybill:export'" @click="download(row)">{{ row.fileName }}</el-button><span v-else>{{ row.fileName }}</span></template>
      </el-table-column>
      <el-table-column label="状态" width="100"><template slot-scope="{ row }"><el-tag size="small" :type="statusType(row.status)">{{ statusText(row.status) }}</el-tag></template></el-table-column>
      <el-table-column v-if="type === 'IMPORT'" label="处理结果" min-width="150"><template slot-scope="{ row }">成功 {{ row.successCount || 0 }} / 失败 {{ row.failureCount || 0 }}<el-popover v-if="row.errors && row.errors.length" placement="bottom" width="420" trigger="click"><div class="record-errors"><p v-for="(error, index) in row.errors" :key="index">{{ error }}</p></div><el-button slot="reference" type="text">查看错误</el-button></el-popover></template></el-table-column>
      <el-table-column label="发起时间" width="170"><template slot-scope="{ row }">{{ formatDate(row.startedTime) }}</template></el-table-column>
      <el-table-column label="完成时间" width="170"><template slot-scope="{ row }">{{ formatDate(row.finishedTime) }}</template></el-table-column>
      <el-table-column prop="operatorName" label="操作人" width="110" show-overflow-tooltip />
    </el-table>
    <el-pagination class="records-pagination" :current-page="page" :page-size="pageSize" :total="total" :page-sizes="[10, 15, 20, 50]" layout="total, sizes, prev, pager, next" @current-change="changePage" @size-change="changeSize" />
  </el-dialog>
</template>

<script>
import dayjs from 'dayjs'
import { getWaybillFileRecords, downloadWaybillFileRecord, isRequestSuccess } from './lingdongApi'
import { downloadWaybillBlob } from './waybillDownload'

export default {
  name: 'WaybillFileRecords',
  props: { visible: Boolean, type: { type: String, default: 'IMPORT' } },
  data() { return { loading: false, items: [], total: 0, page: 1, pageSize: 15, downloading: null, requestId: 0 } },
  beforeDestroy() { this.requestId += 1 },
  methods: {
    open() { this.page = 1; this.items = []; this.total = 0; this.fetchRecords() },
    async fetchRecords() {
      const id = ++this.requestId
      this.loading = true
      try {
        const res = await getWaybillFileRecords({ type: this.type, page: this.page, pageSize: this.pageSize })
        if (id !== this.requestId) return
        if (!isRequestSuccess(res)) throw new Error(res.msg || '获取记录失败')
        this.items = res.data.items || []
        this.total = Number(res.data.total || 0)
      } catch (error) {
        if (id === this.requestId) this.$message.error(error.msg || error.message || '获取记录失败')
      } finally {
        if (id === this.requestId) this.loading = false
      }
    },
    changePage(page) { this.page = page; this.fetchRecords() },
    changeSize(size) { this.pageSize = size; this.page = 1; this.fetchRecords() },
    async download(row) {
      this.downloading = row.id
      try { await downloadWaybillBlob(await downloadWaybillFileRecord(row.id), row.fileName) } catch (error) { this.$message.error(error.msg || error.message || '下载失败') } finally { this.downloading = null }
    },
    formatDate(value) { return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '-' },
    statusText(value) { return { RUNNING: '处理中', SUCCESS: '成功', PARTIAL: '部分成功', FAILED: '失败' }[value] || value },
    statusType(value) { return { SUCCESS: 'success', PARTIAL: 'warning', FAILED: 'danger', RUNNING: 'info' }[value] || 'info' }
  }
}
</script>

<style scoped>
.records-toolbar { display: flex; justify-content: space-between; align-items: center; margin-bottom: 14px; color: #909399; font-size: 13px; }
.records-pagination { margin-top: 18px; text-align: right; }
.record-errors { max-height: 260px; overflow: auto; color: #b45309; font-size: 12px; }
</style>
